//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { PermissionList, Regions, RolePermissionRequest, RolePermissionResponse, Roles, Tenants, UserRoleResponse, UserRoles, Users, Opus, AccessRoles, UserAccessResponse, ApiResponse, PotfModel, ImportantDates, DashboardImages, FileUpload, DataImportRequest, Pipelines, InspectionData, MetoceanPointsData, PredictionRequest, Ticket, SpanResults, SpanLengthResults, SpanHeightResults, PredictionResult, Secrets, PipelineBarChart } from './classes';
import { environment } from 'src/environments/environment';

export const API_BASE_URL = new InjectionToken<string>(environment.apiEndpoint);

export interface ITestClient {
    popup(req: TestRequest): Observable<TestResponse>;
}

@Injectable({
    providedIn: 'root'
})

export class TestClient implements ITestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    popup(req: TestRequest): Observable<TestResponse> {
        let url_ = this.baseUrl + "/api/Test/Popup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPopup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPopup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestResponse>;
        }));
    }

    protected processPopup(response: HttpResponseBase): Observable<TestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRefClient {
}

@Injectable({
    providedIn: 'root'
})

export class RefClient implements IRefClient {
    getStatusPredictionRequest(id: any) {
        throw new Error('Method not implemented.');
    }
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountType(): Observable<RefDto[]> {
        let url_ = this.baseUrl + "/api/Ref/GetAccountType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefDto[]>;
        }));
    }

    protected processGetAccountType(response: HttpResponseBase): Observable<RefDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RefDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllUsers(): Observable<Users[]> {
        let url_ = environment.apiEndpoint + "UserManagement/GetAllUsers";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<Users[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    // Dashboard Charts
    getPipelineByRegion(): Observable<PipelineBarChart[]> {
        let url_ = environment.apiEndpoint + "Pipeline/PipelineByRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPipelineByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPipelineByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PipelineBarChart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PipelineBarChart[]>;
        }));
    }

    protected processGetAllPipelineByRegion(response: HttpResponseBase): Observable<PipelineBarChart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllInspectionPendingImportRequest(): Observable<DataImportRequest[]> {
        let url_ = environment.apiEndpoint + "Pipeline/GetPendingImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllInspectionPendingImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInspectionPendingImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest[]>;
        }));
    }

    protected processGetAllInspectionPendingImportRequest(response: HttpResponseBase): Observable<DataImportRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataImportHistory(requestType: string): Observable<DataImportRequest[]> {
        let url_ = environment.apiEndpoint + "Metocean/GetDataImportRequestHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requestType !== null && requestType !== undefined)
            content_.append("RequestType", requestType.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDataImportHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataImportHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest[]>;
        }));
    }

    protected processGetDataImportHistory(response: HttpResponseBase): Observable<DataImportRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllMPointsPendingImportRequest(): Observable<DataImportRequest[]> {
        let url_ = environment.apiEndpoint + "Metocean/GetPendingImportRequest";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMPointsPendingImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMPointsPendingImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest[]>;
        }));
    }

    protected processGetAllMPointsPendingImportRequest(response: HttpResponseBase): Observable<DataImportRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllImportantDates(): Observable<ImportantDates[]> {
        let url_ = environment.apiEndpoint + "ImportantDate/ImportantDatesList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllImportantDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllImportantDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportantDates[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportantDates[]>;
        }));
    }

    protected processGetAllImportantDates(response: HttpResponseBase): Observable<ImportantDates[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPredictionRequest(): Observable<PredictionRequest[]> {
        let url_ = environment.apiEndpoint + "Model/GetAllPredictionRequest";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPredictionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPredictionRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionRequest[]>;
        }));
    }

    protected processGetAllPredictionRequest(response: HttpResponseBase): Observable<PredictionRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPredictionPlotChart(pipelineName: string, inspectionType: string, year: string, numYear: number, modelType: string, runId: number): Observable<PredictionResult[]> {
        let url_ = environment.apiEndpoint + "Model/GetAllPredictionPlotChart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pipelineName !== null && pipelineName !== undefined)
            content_.append("pipelineName", pipelineName.toString());
        if (inspectionType !== null && inspectionType !== undefined)
            content_.append("inspectionType", inspectionType.toString());
        if (year !== null && year !== undefined)
            content_.append("year", year.toString());
        if (numYear !== null && numYear !== undefined)
            content_.append("numYear", numYear.toString());
        if (modelType !== null && modelType !== undefined)
            content_.append("modelType", modelType.toString());
        if (runId !== null && runId !== undefined)
            content_.append("runId", runId.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPredictionPlotChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPredictionPlotChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionResult[]>;
        }));
    }

    downloadResult(pipelineName: string, inspectionType: string, year: string, numYear: number, modelType: string, maxAllowable: number, runId: number): Observable<Blob> {
        let url = environment.apiEndpoint + "Model/DownloadResult";

        if (pipelineName !== null && pipelineName !== undefined)
            url += "?PipelineId=" + encodeURIComponent("" + pipelineName.toString()) + "&";
        if (inspectionType !== null && inspectionType !== undefined)
            url += "InspectionType=" + encodeURIComponent("" + inspectionType.toString()) + "&";
        if (year !== null && year !== undefined)
            url += "Year=" + encodeURIComponent("" + year.toString()) + "&";
        if (numYear !== null && numYear !== undefined)
            url += "NumOfYear=" + encodeURIComponent("" + numYear.toString()) + "&";
        if (modelType !== null && modelType !== undefined)
            url += "ModelType=" + encodeURIComponent("" + modelType.toString()) + "&";
        if (maxAllowable !== null && maxAllowable !== undefined)
            url += "MaxAllowable=" + encodeURIComponent("" + maxAllowable.toString()) + "&";
        if (runId !== null && runId !== undefined)
            url += "RunId=" + encodeURIComponent("" + runId.toString()) + "&";

        url = url.replace(/[?&]$/, "");

        return this.http.get(url, {
            responseType: "blob",
        });
    }

    protected processGetAllPredictionPlotChart(response: HttpResponseBase): Observable<PredictionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPredictionPlot(pipelineName: string, inspectionType: string, year: string, maxAllowable: number, numYear: number, modelType: string, runId: number): Observable<PredictionResult[]> {
        let url_ = environment.apiEndpoint + "Model/GetPlotPredictionData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pipelineName !== null && pipelineName !== undefined)
            content_.append("pipelineName", pipelineName.toString());
        if (inspectionType !== null && inspectionType !== undefined)
            content_.append("inspectionType", inspectionType.toString());
        if (year !== null && year !== undefined)
            content_.append("year", year.toString());
        if (maxAllowable !== null && maxAllowable !== undefined)
            content_.append("maxAllowable", maxAllowable.toString());
        if (modelType !== null && modelType !== undefined)
            content_.append("modelType", modelType.toString());
        if (numYear !== null && numYear !== undefined)
            content_.append("numYear", numYear.toString());
        if (runId !== null && runId !== undefined)
            content_.append("runId", runId.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPredictionPlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPredictionPlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionResult[]>;
        }));
    }

    protected processGetAllPredictionPlot(response: HttpResponseBase): Observable<PredictionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDashboardImages(): Observable<DashboardImages[]> {
        let url_ = environment.apiEndpoint + "Dashboard/DashboardImageList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDashboardImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDashboardImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardImages[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardImages[]>;
        }));
    }

    protected processGetAllDashboardImages(response: HttpResponseBase): Observable<DashboardImages[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPipelines(): Observable<Pipelines[]> {
        let url_ = environment.apiEndpoint + "Pipeline/PipelineList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPipelines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPipelines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines[]>;
        }));
    }

    protected processGetAllPipelines(response: HttpResponseBase): Observable<Pipelines[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllRoles(): Observable<Roles[]> {
        let url_ = environment.apiEndpoint + "RoleManagement/GetAllRoles";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles[]>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<Roles[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUser(req: Users): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/SaveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processSaveUser(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveTicket(req: Ticket): Observable<Ticket> {
        let url_ = environment.apiEndpoint + "SupportTicket/saveSupportTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTicket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ticket>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ticket>;
        }));
    }

    protected processSaveTicket(response: HttpResponseBase): Observable<Ticket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePredictionRequest(req: PredictionRequest): Observable<PredictionRequest> {
        let url_ = environment.apiEndpoint + "Model/SavePredictionRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSavePredictionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePredictionRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionRequest>;
        }));
    }

    protected processSavePredictionRequest(response: HttpResponseBase): Observable<PredictionRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePipeline(req: Pipelines): Observable<Pipelines> {
        let url_ = environment.apiEndpoint + "Pipeline/savePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSavePipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePipeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines>;
        }));
    }

    protected processSavePipeline(response: HttpResponseBase): Observable<Pipelines> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePipeline(req: Pipelines): Observable<Pipelines> {
        let url_ = environment.apiEndpoint + "Pipeline/updatePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePipeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines>;
        }));
    }

    protected processUpdatePipeline(response: HttpResponseBase): Observable<Pipelines> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveDataImportRequest(req: DataImportRequest): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Pipeline/ApproveDataImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDataImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    updateDataImportRequestFile(req: DataImportRequest): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Pipeline/UpdateDataImportRequestFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDataImportRequestFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDataImportRequestFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    protected processUpdateDataImportRequestFile(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    protected processDataImportRequest(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    DeleteDataImportRequest(req: DataImportRequest): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Pipeline/DeleteDataImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDataImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    protected processDeleteDataImportRequest(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveMPointsDataImportRequest(req: DataImportRequest): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Metocean/ApproveDataImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMPointsDataImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMPointsDataImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    protected processMPointsDataImportRequest(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    saveImportantDate(req: ImportantDates): Observable<ImportantDates> {
        let url_ = environment.apiEndpoint + "ImportantDate/saveImportantDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveImportantDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveImportantDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportantDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportantDates>;
        }));
    }

    protected processSaveImportantDate(response: HttpResponseBase): Observable<ImportantDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveDashboardImage(req: DashboardImages): Observable<DashboardImages> {
        let url_ = environment.apiEndpoint + "Dashboard/SaveDashboardImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveDashboardImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDashboardImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardImages>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardImages>;
        }));
    }

    protected processSaveDashboardImage(response: HttpResponseBase): Observable<DashboardImages> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
    
    saveInspectionDataImportRequest(req: DataImportRequest): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Pipeline/SaveDataImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveInspectionDataImportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInspectionDataImportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    protected processSaveInspectionDataImportRequest(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadImage(req: FileUpload): Observable<string> {
        let url_ = environment.apiEndpoint + "FileUpload/UploadToAzure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUserRoles(req: UserRoles): Observable<UserRoles> {
        let url_ = environment.apiEndpoint + "UserManagement/UpdateUserRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoles>;
        }));
    }

    protected processSaveUserRoles(response: HttpResponseBase): Observable<UserRoles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveRoles(req: Roles): Observable<Roles> {
        let url_ = environment.apiEndpoint + "RoleManagement/SaveRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles>;
        }));
    }

    protected processSaveRole(response: HttpResponseBase): Observable<Roles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(id: string): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePipelines(id: string): Observable<Pipelines> {
        let url_ = environment.apiEndpoint + "Pipeline/DeletePipeline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("PipelineID", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePipeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines>;
        }));
    }

    protected processDeletePipeline(response: HttpResponseBase): Observable<Pipelines> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDashboardImage(id: string): Observable<DashboardImages> {
        let url_ = environment.apiEndpoint + "Dashboard/DeleteDashboardImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDashboardImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDashboardImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardImages>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardImages>;
        }));
    }

    protected processDeleteDashboardImage(response: HttpResponseBase): Observable<DashboardImages> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteImportantDate(id: string): Observable<ImportantDates> {
        let url_ = environment.apiEndpoint + "ImportantDate/DeleteImportantDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteImportantDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImportantDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportantDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportantDates>;
        }));
    }

    protected processDeleteImportantDate(response: HttpResponseBase): Observable<ImportantDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    deleteRole(id: string): Observable<Roles> {
        let url_ = environment.apiEndpoint + "RoleManagement/DeleteRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<Roles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserById(id: string): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/GetUserData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("userId", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupportTicketListByEmail(email: string): Observable<Ticket[]> {
        let url_ = environment.apiEndpoint + "SupportTicket/SupportTicketListByEmail";
        url_ = url_.replace(/[?&]$/, "");

        if (email !== undefined && email !== null)
            url_ += "?email=" + encodeURIComponent("" + email.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSupportTicketListByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportTicketListByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ticket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ticket[]>;
        }));
    }

    protected processGetSupportTicketListByEmail(response: HttpResponseBase): Observable<Ticket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPredictionRequestById(id: string): Observable<PredictionRequest> {
        let url_ = environment.apiEndpoint + "Model/GetPredictionRequestDataById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPredictionRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredictionRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredictionRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredictionRequest>;
        }));
    }

    protected processGetPredictionRequestById(response: HttpResponseBase): Observable<PredictionRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpanHeight(years: number): Observable<SpanHeightResults[]> {
        let url_ = environment.apiEndpoint + "Model/GetSpanHeight";
        url_ = url_.replace(/[?&]$/, "");

        if (years !== undefined && years !== null)
            url_ += "?interval=" + encodeURIComponent("" + years.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSpanHeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpanHeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanHeightResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanHeightResults[]>;
        }));
    }

    protected processGetSpanHeight(response: HttpResponseBase): Observable<SpanHeightResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpanLength(years: number): Observable<SpanLengthResults[]> {
        let url_ = environment.apiEndpoint + "Model/GetSpanLength";
        url_ = url_.replace(/[?&]$/, "");

        if (years !== undefined && years !== null)
            url_ += "?interval=" + encodeURIComponent("" + years.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSpanLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpanLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanLengthResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanLengthResults[]>;
        }));
    }

    protected processGetSpanLength(response: HttpResponseBase): Observable<SpanLengthResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllResultsBarChart(): Observable<SpanResults[]> {
        let url_ = environment.apiEndpoint + "Model/GetAllResultsBarChart";

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllResultsBarChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllResultsBarChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanResults[]>;
        }));
    }

    protected processGetAllResultsBarChart(response: HttpResponseBase): Observable<SpanResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllResultsHeight(years: number): Observable<SpanResults[]> {
        let url_ = environment.apiEndpoint + "Model/GetAllResultsHeight";
        url_ = url_.replace(/[?&]$/, "");

        if (years !== undefined && years !== null)
            url_ += "?interval=" + encodeURIComponent("" + years.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllResultsHeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllResultsHeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanResults[]>;
        }));
    }

    protected processGetAllResultsHeight(response: HttpResponseBase): Observable<SpanResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllResultsLength(years: number): Observable<SpanResults[]> {
        let url_ = environment.apiEndpoint + "Model/GetAllResultsLength";
        url_ = url_.replace(/[?&]$/, "");

        if (years !== undefined && years !== null)
            url_ += "?interval=" + encodeURIComponent("" + years.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Accept": "application/json"
            })
          };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllResultsLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllResultsLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpanResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpanResults[]>;
        }));
    }

    protected processGetAllResultsLength(response: HttpResponseBase): Observable<SpanResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPipelineYear(): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/PipelineYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPipelineYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPipelineYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllPipelineYear(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPipelineType(): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/PipelineType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPipelineType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPipelineType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }
    
    protected processGetAllPipelineType(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDSPipelineYear(id: string): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/DSPipelineYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("pipelineId", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDSPipelineYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDSPipelineYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDSPipelineYear(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(req: Users): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateImportantDate(req: ImportantDates): Observable<ImportantDates> {
        let url_ = environment.apiEndpoint + "ImportantDate/updateImportantDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateImportantDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImportantDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportantDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportantDates>;
        }));
    }

    getAllDSPipelineType(id: string, year: number): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/DSPipelineType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (year !== null && year !== undefined)
            content_.append("pipelineYear", year.toString());

        if (id !== null && id !== undefined)
            content_.append("pipelineId", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDSPipelineType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDSPipelineType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDSPipelineType(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDSInspectionData(id: string, type: string, year: number): Observable<InspectionData[]> {
        let url_ = environment.apiEndpoint + "Pipeline/GetDSInspectionDataByInspectionId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("pipelineName", id.toString());

        if (type !== null && type !== undefined)
            content_.append("inspectionType", type.toString());

        if (year !== null && year !== undefined)
            content_.append("year", year.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDSInspectionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDSInspectionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionData[]>;
        }));
    }

    protected processGetDSInspectionData(response: HttpResponseBase): Observable<InspectionData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDSInspectionDataByPName(pName: string): Observable<InspectionData[]> {
        let url_ = environment.apiEndpoint + "Pipeline/GetDSInspectionDataByPName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pName !== null && pName !== undefined)
            content_.append("PipelineName", pName.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDSInspectionDataByPName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDSInspectionDataByPName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionData[]>;
        }));
    }

    protected processGetDSInspectionDataByPName(response: HttpResponseBase): Observable<InspectionData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMetoceanPointsData(id: string): Observable<MetoceanPointsData[]> {
        let url_ = environment.apiEndpoint + "Pipeline/GetMetoceanPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("PipelineID", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMetoceanPointsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetoceanPointsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MetoceanPointsData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MetoceanPointsData[]>;
        }));
    }

    protected processGetMetoceanPointsData(response: HttpResponseBase): Observable<MetoceanPointsData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMetoceanMaxDate(pipelineName: string): Observable<string> {
        let url_ = environment.apiEndpoint + "Metocean/GetAllMetoceanMaxDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pipelineName !== null && pipelineName !== undefined)
            content_.append("pipelineName", pipelineName.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMetoceanMaxDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetoceanMaxDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMetoceanMaxDate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPipelineById(id: string): Observable<Pipelines> {
        let url_ = environment.apiEndpoint + "Pipeline/GetPipelineData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("PipelineId", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPipelineById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPipelineById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines>;
        }));
    }

    protected processGetPipelineById(response: HttpResponseBase): Observable<Pipelines> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getImportantDateById(id: string): Observable<ImportantDates> {
        let url_ = environment.apiEndpoint + "ImportantDate/GetImportantDateDataById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImportantDateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportantDateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportantDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportantDates>;
        }));
    }

    protected processGetImportantDateById(response: HttpResponseBase): Observable<ImportantDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserByEmail(email: string): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/GetUserByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("email", email.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processGetUserByEmail(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserRoleById(id: string): Observable<UserRoleResponse[]> {
        let url_ = environment.apiEndpoint + "UserManagement/GetUserRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== undefined && id !== null)
            url_ += "?UserId=" + encodeURIComponent("" + id.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleResponse[]>;
        }));
    }

    protected processGetUserRoleById(response: HttpResponseBase): Observable<UserRoleResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(pipeline: string, type: string, year: string): Observable<Blob> {
        // Adjust the API endpoint according to your API URL
        var url = environment.apiEndpoint + "Pipeline/ExportToExcel";
        if (pipeline !== undefined && pipeline !== null)
            url += "?PipelineName=" + encodeURIComponent("" + pipeline.toString()) + "&";

        if (type !== undefined && type !== null)
            url += "InspectionType=" + encodeURIComponent("" + type.toString()) + "&";

        if (year !== undefined && year !== null)
            url += "Year=" + encodeURIComponent("" + year.toString()) + "&";

        url = url.replace(/[?&]$/, "");

        return this.http.get(url, { responseType: 'blob' });
    }

    getUserAccessById(id: string): Observable<UserAccessResponse[]> {
        let url_ = environment.apiEndpoint + "UserManagement/GetUserAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserAccessById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccessById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessResponse[]>;
        }));
    }

    protected processGetUserAccessById(response: HttpResponseBase): Observable<UserAccessResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataImportRequestById(id: string): Observable<DataImportRequest> {
        let url_ = environment.apiEndpoint + "Pipeline/GetDataImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDataImportRequestById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataImportRequestById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataImportRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataImportRequest>;
        }));
    }

    protected processGetDataImportRequestById(response: HttpResponseBase): Observable<DataImportRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    protected processUpdateImportantDate(response: HttpResponseBase): Observable<ImportantDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserRoles(req: UserRoles): Observable<UserRoles> {
        let url_ = environment.apiEndpoint + "UserManagement/UpdateUserRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoles>;
        }));
    }

    protected processUpdateUserRoles(response: HttpResponseBase): Observable<UserRoles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUserAccess(req: UserRoles): Observable<AccessRoles> {
        let url_ = environment.apiEndpoint + "UserManagement/UpdateUserAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveUserAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessRoles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessRoles>;
        }));
    }

    protected processSaveUserAccess(response: HttpResponseBase): Observable<AccessRoles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleById(id: string): Observable<Roles> {
        let url_ = environment.apiEndpoint + "RoleManagement/GetRoleData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("roleid", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles>;
        }));
    }

    protected processGetRoleById(response: HttpResponseBase): Observable<Roles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRole(req: Roles): Observable<Roles> {
        let url_ = environment.apiEndpoint + "RoleManagement/UpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<Roles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTenantById(id: string): Observable<Tenants> {
        let url_ = environment.apiEndpoint + "Tenant/GetTenantDataById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenants>;
        }));
    }

    protected processGetTenantById(response: HttpResponseBase): Observable<Tenants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTenant(req: Tenants): Observable<Tenants> {
        let url_ = environment.apiEndpoint + "Tenant/updateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenants>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<Tenants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSecretFromKeyVault(req: string[]): Observable<Secrets[]> {
        let url_ = environment.apiEndpoint + "PermissionManagement/SecretVault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSecretFromKeyVault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecretFromKeyVault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Secrets[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Secrets[]>;
        }));
    }

    protected processGetSecretFromKeyVault(response: HttpResponseBase): Observable<Secrets[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPermissionsByUserId(id: string): Observable<RolePermissionResponse[]> {
        let url_ = environment.apiEndpoint + "PermissionManagement/GetAllPermissionsByUserId";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== undefined && id !== null)
            url_ += "?UserId=" + encodeURIComponent("" + id.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissionsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissionsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionResponse[]>;
        }));
    }

    protected processGetAllPermissionsByUserId(response: HttpResponseBase): Observable<RolePermissionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPermissionsByUserEmail(id: string): Observable<RolePermissionResponse[]> {
        let url_ = environment.apiEndpoint + "PermissionManagement/GetAllPermissionsByUserEmail";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("userId", id.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissionsByUserEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissionsByUserEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionResponse[]>;
        }));
    }

    protected processGetAllPermissionsByUserEmail(response: HttpResponseBase): Observable<RolePermissionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPermisions(): Observable<PermissionList[]> {
        let url_ = environment.apiEndpoint + "PermissionManagement/PermissionsList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionList[]>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPermissionsByRole(id: string): Observable<RolePermissionResponse[]> {
        let url_ = environment.apiEndpoint + "PermissionManagement/GetRolePermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== undefined && id !== null)
            url_ += "?RoleId=" + encodeURIComponent("" + id.toString()) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissionsByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissionsByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionResponse[]>;
        }));
    }

    protected processGetAllPermissionsByRole(response: HttpResponseBase): Observable<RolePermissionResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRolePermission(req: RolePermissionRequest): Observable<RolePermissionRequest> {
        let url_ = environment.apiEndpoint + "PermissionManagement/UpdateRolePermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRolePermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRolePermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionRequest>;
        }));
    }

    protected processUpdateRolePermission(response: HttpResponseBase): Observable<RolePermissionRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettingByName(name: string): Observable<string> {
        let url_ = environment.apiEndpoint + "Application/GetSettingByName";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("settingName", name);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSettingByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSettingByName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllRegions(): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/RegionList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllDSPipelines(): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/DSPipelineList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDSPipelines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDSPipelines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllDSPipelines(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMasterPipelineList(): Observable<string[]> {
        let url_ = environment.apiEndpoint + "Pipeline/MasterPipelineList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMasterPipelineList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterPipelineList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetMasterPipelineList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRolesList(): Observable<Roles[]> {
        let url_ = environment.apiEndpoint + "RoleManagement/RolesList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRolesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles[]>;
        }));
    }

    protected processGetRolesList(response: HttpResponseBase): Observable<Roles[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    getAllDSPipelineList(): Observable<Pipelines[]> {
        let url_ = environment.apiEndpoint + "Pipeline/AllDSPipelineList";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDSPipelineList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDSPipelineList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pipelines[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pipelines[]>;
        }));
    }

    protected processGetAllDSPipelineList(response: HttpResponseBase): Observable<Pipelines[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    getAllRegionsByOpu(opu: string): Observable<Regions[]> {
        let url_ = environment.apiEndpoint + "Region/GetAllRegionByOpu";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (opu !== null && opu !== undefined)
            content_.append("opu", opu);

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllActiveRegionByOpu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveRegionByOpu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Regions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Regions[]>;
        }));
    }

    protected processGetAllActiveRegionByOpu(response: HttpResponseBase): Observable<Regions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllOpu(): Observable<Opus[]> {
        let url_ = environment.apiEndpoint + "Opu/GetAllOpu";
        console.log(url_);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllOpu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOpu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Opus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Opus[]>;
        }));
    }

    protected processGetAllOpu(response: HttpResponseBase): Observable<Opus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200.result)) {
                    result200 = [] as any;
                    for (let item of resultData200.result)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validatePotf(token: string): Observable<PotfModel> {
        let url_ = environment.apiEndpoint + "UserManagement/ValidatePOTF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (token !== null && token !== undefined)
            content_.append("token", token.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob",
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePotf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePotf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PotfModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PotfModel>;
        }));
    }

    protected processValidatePotf(response: HttpResponseBase): Observable<PotfModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validatePotfUser(userEmail: string): Observable<Users> {
        let url_ = environment.apiEndpoint + "UserManagement/ValidatePOTFUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userEmail !== null && userEmail !== undefined)
            content_.append("userEmail", userEmail.toString());

        let options_: any = {
            observe: "response",
            body: content_,
            responseType: "blob"
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePotfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePotfUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Users>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Users>;
        }));
    }

    protected processValidatePotfUser(response: HttpResponseBase): Observable<Users> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestResponse.fromJS(resultData200);
                return _observableOf(resultData200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountClient {
    login(req: LoginModelRequest): Observable<LoginModelResponse>;
    register(dto: UserProfileNewDto): Observable<number>;
    uploadProfilePicture(userProfileId: number | null | undefined, image: FileParameter | null | undefined): Observable<boolean>;
    getProfilePicture(guid: string | undefined): Observable<FileResponse>;
    testGetUser(guid: string | undefined): Observable<number>;
    getUserApproval(fullName: string | null | undefined): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})

export class AccountClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(req: LoginModelRequest): Observable<LoginModelResponse> {
        let url_ = this.baseUrl + "/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginModelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginModelResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginModelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoginModelResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    register(dto: UserProfileNewDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadProfilePicture(userProfileId: number | null | undefined, image: FileParameter | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Account/UploadProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userProfileId !== null && userProfileId !== undefined)
            content_.append("UserProfileId", userProfileId.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadProfilePicture(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfilePicture(guid: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/GetProfilePicture?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testGetUser(guid: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Account/TestGetUser?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTestGetUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserApproval(fullName: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Account/GetUserApproval?";
        if (fullName !== undefined && fullName !== null)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserApproval(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class TestResponse implements ITestResponse {
    anything?: string;

    constructor(data?: ITestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anything = _data["anything"];
        }
    }

    static fromJS(data: any): TestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anything"] = this.anything;
        return data;
    }
}

export interface ITestResponse {
    anything?: string;
}

export class TestRequest implements ITestRequest {
    anything?: string;

    constructor(data?: ITestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anything = _data["anything"];
        }
    }

    static fromJS(data: any): TestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anything"] = this.anything;
        return data;
    }
}

export interface ITestRequest {
    anything?: string;
}

export class RefDto implements IRefDto {
    id?: number;
    name?: string;

    constructor(data?: IRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RefDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRefDto {
    id?: number;
    name?: string;
}

export class LoginModelResponse implements ILoginModelResponse {
    userId?: number;
    name?: string;
    role?: string;
    token?: string;

    constructor(data?: ILoginModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["role"] = this.role;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoginModelResponse {
    userId?: number;
    name?: string;
    role?: string;
    token?: string;
}

export class LoginModelRequest implements ILoginModelRequest {
    username?: string;
    password?: string;

    constructor(data?: ILoginModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModelRequest {
    username?: string;
    password?: string;
}

export class UserProfileNewDto implements IUserProfileNewDto {
    id?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    staffNo?: string | undefined;
    mobileNo?: string | undefined;
    identificationNo?: string | undefined;
    refAccountTypeId?: number | undefined;
    refGenderId?: number | undefined;
    refNationalityId?: number | undefined;
    refCompanyId?: number | undefined;
    refOpuid?: number | undefined;
    refDivisionId?: number | undefined;
    refDepartmentId?: number | undefined;
    refDesignationId?: number | undefined;
    engagementStartDate?: Date | undefined;
    engagementEndDate?: Date | undefined;
    hiringManagerId?: number | undefined;
    reportingManagerId?: number | undefined;
    contractReferenceNo?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    refDepartmentCostCenterId?: number | undefined;
    userProfilePermission?: UserProfilePermissionDto[];

    constructor(data?: IUserProfileNewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.staffNo = _data["staffNo"];
            this.mobileNo = _data["mobileNo"];
            this.identificationNo = _data["identificationNo"];
            this.refAccountTypeId = _data["refAccountTypeId"];
            this.refGenderId = _data["refGenderId"];
            this.refNationalityId = _data["refNationalityId"];
            this.refCompanyId = _data["refCompanyId"];
            this.refOpuid = _data["refOpuid"];
            this.refDivisionId = _data["refDivisionId"];
            this.refDepartmentId = _data["refDepartmentId"];
            this.refDesignationId = _data["refDesignationId"];
            this.engagementStartDate = _data["engagementStartDate"] ? new Date(_data["engagementStartDate"].toString()) : <any>undefined;
            this.engagementEndDate = _data["engagementEndDate"] ? new Date(_data["engagementEndDate"].toString()) : <any>undefined;
            this.hiringManagerId = _data["hiringManagerId"];
            this.reportingManagerId = _data["reportingManagerId"];
            this.contractReferenceNo = _data["contractReferenceNo"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : <any>undefined;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            this.refDepartmentCostCenterId = _data["refDepartmentCostCenterId"];
            if (Array.isArray(_data["userProfilePermission"])) {
                this.userProfilePermission = [] as any;
                for (let item of _data["userProfilePermission"])
                    this.userProfilePermission!.push(UserProfilePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfileNewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileNewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["staffNo"] = this.staffNo;
        data["mobileNo"] = this.mobileNo;
        data["identificationNo"] = this.identificationNo;
        data["refAccountTypeId"] = this.refAccountTypeId;
        data["refGenderId"] = this.refGenderId;
        data["refNationalityId"] = this.refNationalityId;
        data["refCompanyId"] = this.refCompanyId;
        data["refOpuid"] = this.refOpuid;
        data["refDivisionId"] = this.refDivisionId;
        data["refDepartmentId"] = this.refDepartmentId;
        data["refDesignationId"] = this.refDesignationId;
        data["engagementStartDate"] = this.engagementStartDate ? this.engagementStartDate.toISOString() : <any>undefined;
        data["engagementEndDate"] = this.engagementEndDate ? this.engagementEndDate.toISOString() : <any>undefined;
        data["hiringManagerId"] = this.hiringManagerId;
        data["reportingManagerId"] = this.reportingManagerId;
        data["contractReferenceNo"] = this.contractReferenceNo;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["refDepartmentCostCenterId"] = this.refDepartmentCostCenterId;
        if (Array.isArray(this.userProfilePermission)) {
            data["userProfilePermission"] = [];
            for (let item of this.userProfilePermission)
                data["userProfilePermission"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserProfileNewDto {
    id?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    staffNo?: string | undefined;
    mobileNo?: string | undefined;
    identificationNo?: string | undefined;
    refAccountTypeId?: number | undefined;
    refGenderId?: number | undefined;
    refNationalityId?: number | undefined;
    refCompanyId?: number | undefined;
    refOpuid?: number | undefined;
    refDivisionId?: number | undefined;
    refDepartmentId?: number | undefined;
    refDesignationId?: number | undefined;
    engagementStartDate?: Date | undefined;
    engagementEndDate?: Date | undefined;
    hiringManagerId?: number | undefined;
    reportingManagerId?: number | undefined;
    contractReferenceNo?: string | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    refDepartmentCostCenterId?: number | undefined;
    userProfilePermission?: UserProfilePermissionDto[];
}

export class UserProfilePermissionDto implements IUserProfilePermissionDto {
    refLevel1Id?: number | undefined;
    refLevel2Id?: number | undefined;
    refModuleId?: number | undefined;
    refRoleId?: number | undefined;

    constructor(data?: IUserProfilePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refLevel1Id = _data["refLevel1Id"];
            this.refLevel2Id = _data["refLevel2Id"];
            this.refModuleId = _data["refModuleId"];
            this.refRoleId = _data["refRoleId"];
        }
    }

    static fromJS(data: any): UserProfilePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfilePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refLevel1Id"] = this.refLevel1Id;
        data["refLevel2Id"] = this.refLevel2Id;
        data["refModuleId"] = this.refModuleId;
        data["refRoleId"] = this.refRoleId;
        return data;
    }
}

export interface IUserProfilePermissionDto {
    refLevel1Id?: number | undefined;
    refLevel2Id?: number | undefined;
    refModuleId?: number | undefined;
    refRoleId?: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}